import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import classNames from "classnames"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import attnLogo from "~/images/attn-logo-navy.svg"

const AboutSectionInfoBox = ({ className, heading, paragraph, Image }) => {
  return (
    <div className={classNames("flex flex-col items-center p-6", className)}>
      <div className="mb-2 flex">{Image}</div>
      <h3 className="font-heading text-2-7xl lg:text-3-2xl uppercase mt-4 text-center leading-none">
        {heading}
      </h3>
      <div className="w-full block">
        <p className="text-center mt-2">{paragraph}</p>
      </div>
    </div>
  )
}

const AboutSection = () => {
  const data = useStaticQuery(graphql`
    query AboutQuery {
      sceLogo: file(name: { eq: "sce-logo" }) {
        childImageSharp {
          fluid(maxHeight: 130) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      chicagoIdeasLogo: file(name: { eq: "chicago-logo-horizontal" }) {
        childImageSharp {
          fluid(maxHeight: 150) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)
  const { sceLogo, chicagoIdeasLogo } = data
  const companies = [
    {
      heading: "ABOUT SCE",
      paragraph:
        "By investing in an ecosystem of anytime, anywhere learning, the Susan Crown Exchange (SCE) prepares youth to thrive in a rapidly changing world. SCE primarily supports organizations that operate in out-of-school time, prioritizing nonprofits that promote social and emotional learning and explore the relationships between technology and society.",
      Image: (
        <OutboundLink
          className="sce-logo-about"
          href="http://www.scefdn.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Img fluid={sceLogo.childImageSharp.fluid} alt="SCE Logo" />
        </OutboundLink>
      ),
    },
    {
      heading: "ABOUT CHICACO IDEAS",
      paragraph:
        "Chicago Ideas is a nonprofit platform that exists to connect and inspire individuals to create a more joyous, thriving world for everyone. The Chicago Ideas Youth Program, which serves 1,400 students annually, provides a platform where high school students can internalize a leadership mentality and gain exposure to ideas that will increase their capacity to impact the world around them.",
      Image: (
        <OutboundLink
          className="chicago-logo-about"
          href=" https://www.chicagoideas.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Img
            fluid={chicagoIdeasLogo.childImageSharp.fluid}
            alt="Chicago Ideas Logo"
          />
        </OutboundLink>
      ),
    },
    {
      heading: "ABOUT ATTN",
      paragraph:
        "ATTN: is a media company that breaks down important societal topics and conversations into digestible, entertaining content across all platforms. We are leaders when it comes to reaching people who want context on the issues and conversations that matter to them. We bridge entertainment with topical issues to explain the world around us.",
      Image: (
        <OutboundLink
          className="attn-logo-about"
          href="https://www.attn.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={attnLogo} alt="Attn Logo" className="w-full" />
        </OutboundLink>
      ),
    },
  ]
  return (
    <section className="flex flex-wrap justify-center py-12 px-content-mobile md:px-content mx-auto max-w-about xl:max-w-about-xl bg-circles-about">
      {companies.map((company, index) => (
        <AboutSectionInfoBox
          className="w-full md:w-1/2 xl:px-12"
          {...company}
          key={index}
        />
      ))}
    </section>
  )
}

export default AboutSection
